/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export const classificationSdkLink = 'https://aka.ms/use-sdk-classification';

export const extractionSdkLink = 'https://aka.ms/use-sdk-cner';

export const sentimentSdkLink =
    'https://learn.microsoft.com/en-us/azure/cognitive-services/language-service/sentiment-opinion-mining/quickstart?tabs=windows&pivots=programming-language-csharp';

export const cluSdkLink = 'https://aka.ms/use-sdk-clu';
export const orchestrationSdkLink = 'https://aka.ms/use-sdk-orchestration';

export const singleClassificationJavaGithubSampleLink = 'https://aka.ms/sdk-sample-java-single-classification';
export const singleClassificationPythonGithubSampleLink = 'https://aka.ms/sdk-samples-python-single-classification';
export const singleClassificationCsharpGithubSampleLink = 'https://aka.ms/sdk-samples-dot-net-single-classification';
export const singleClassificationJavaScriptGithubSampleLink = 'https://aka.ms/sdk-sample-java-script-single-classification';

export const multiClassificationJavaGithubSampleLink = 'https://aka.ms/sdk-sample-java-multi-classification';
export const multiClassificationPythonGithubSampleLink = 'https://aka.ms/sdk-samples-python-multi-classification';
export const multiClassificationCsharpGithubSampleLink = 'https://aka.ms/sdk-samples-dot-net-multi-classification';
export const multiClassificationJavaScriptGithubSampleLink = 'https://aka.ms/sdk-samples-java-script-multi-classification';

export const extractionJavaGithubSampleLink = 'https://aka.ms/sdk-samples-java';
export const extractionPythonGithubSampleLink = 'https://aka.ms/sdk-samples-python';
export const extractionCsharpGithubSampleLink = 'https://aka.ms/sdk-samples-dot-net';
export const extractionJavaScriptGithubSampleLink = 'https://aka.ms/sdk-samples-java-script';

export const cluCsharpGithubSampleLink = 'https://aka.ms/sdk-sample-conversation-dot-net';
export const cluPythonGithubSampleLink = 'https://aka.ms/sdk-samples-conversation-python';

export const sentimentGithubSampleLink =
    'https://github.com/Azure/azure-sdk-for-net/tree/main/sdk/textanalytics/Azure.AI.TextAnalytics/samples';
